<template>
    <div class="andes-tag">
        <div class="andes-tag__tag-hover-surface">
            <div class="andes-tag__label">{{tagName}}</div>
            <span 
            @click="eraseTag"
            style="margin:5px;cursor:pointer;">
                <i class="fa fa-times" aria-hidden="true"></i>
            </span>
        </div>
        
    </div>
</template>

<script>
    export default {
        props: {
            tagName: {
                type: String
            }
        },
        methods: {
            eraseTag() {
                this.$emit('eraseTag');
            }
        },
    }
</script>

<style lang="scss" scoped>
    .andes-tag{
        margin: 0;
        padding: 0;
        border-radius: 1px;
        max-height: 26px;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        display: inline-block;
        margin: 5px;
        height: 2.1538461538em;
        .andes-tag__tag-hover-surface{
            background-color: #cecece85;
            border-radius: 2px;
            height: 100%;
            display: inline-flex;
            align-items: center;
            .andes-tag__label{
                margin-left: 8px;
                margin-right: 3px;
            }
        }
    }
</style>